import { AnaColumn, costantValue } from "../forms-template.service";
import { aspect } from "./aspect";
import { createGridConfig, gridSimple } from "./gridSettings/gridSettings";

export const cantiere: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'descrizioneSoggetto - $descrizioneSede',
      titleForm: 'descrizioneSoggetto - $descrizioneSede',
      breadcrumbCaption: 'Cantieri esterni',
      startTemplate: 'grid',
      campoTitle: ['descrizioneSede', 'descrizioneSoggetto'],
      service: 'cantiere',
      api: 'cantiere',
      filterList: '/$idSede',
      filterEditor: '?id=$',
      helpDoc: 'CantieriEsterni.html',
      queryFilter: [

      ],
      idTabRif: [

        {
          key: 'idSede',
          value: 'idSede'
        },


      ],
      formType: 'simple',
      masterKey: 'id',
      nCol: 1,
      toolbarSettings: {
        service: 'cantiere',

      }





    }

  },

  {
    itemType: "group", groupWidth:560, groupDataField: 'datiCantiere', colCount: "3", caption: 'Descrizione e indirizzo cantiere esterno - Rifiuti fuori unità locale', colSpan: "2", data: [

      {
        orderGriglia: 1,
        type: 'campo',
        dataField: "descrizione",
        caption: "Descrizione",

        maxLength: "45",
        showInColumnChooser: true, allowHiding: false,
        nCol: 10,
        colSpan: 3,
        validation: [{
          type: 'required', message: 'Descrizione obbligatorio'
        }]
      },

      {
        orderGriglia: 2,
        showInColumnChooser: true, allowHiding: false,
        type: 'campo', dataField: "indirizzo",
        nCol: 7,
        caption: "Indirizzo",
        maxSize: 35,
        maxLength: "35",
        validation: [{
          type: 'required', message: 'Indirizzo obbligatorio'
        }]
      },
      {
        type: 'empty',
        colSpan: '1',
        dataField: "", dataType: "", hideOnEdit: false,
      },
      {
        showInColumnChooser: true,
        allowHiding: false,
        orderGriglia: 3,
        type: 'campo',
        dataField: "civico",
        caption: "Civico",
        dataType: "",
        nCol: 3,
        maxSize: 7,
        maxLength: "7"
      },
     

      {
        colVisible: false,
        orderGriglia: 5,
        type: 'campo',
        dataField: "frazione",
        caption: "Frazione",
        maxSize: 45,
        maxLength: "45",
        nCol: 10,
        colSpan: 3
      },
      {
        colVisible: false,
        visible:false,
        class:'d-none',
        type: 'campo',
        dataField: "istat",
      },


      {
        type: 'campoSpecial',
        class: "required",
        dataField: "comune",
        caption: "Comune",
        dataType: "",
        maxLength: '42',
        maxSize: 45, colVisible: true,
        orderGriglia: 4,
        allowEditing: true,
        showInColumnChooser: true, allowHiding: false,
        disableOnUpdate: false,
        nCol: 6,
        validation: [
          { type: "required", message: "Comune obbligatorio" }
        ],
        dynamic: {
          service: 'comune',
          dataSource: 'comune',
          queryString: '?$orderby=Descrizione asc',
          autocomplete: false,
          checkValue: {
            checkValueMessage: 'Comune inesistente, vuoi continuare?',
            forceInsert: true
          },
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Elenco comuni Italia",

          componentType: 'dynamicGrid',

          related: ['cap', 'siglaProvincia|provincia', 'id|istat'],

          buttonOption: {
            text: 'Comuni',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Comuni',
            name: 'Comuni',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridSimple,
            colonne: [
              { type: 'campo', dataField: "id", dataType: "string", caption: "ISTAT", colWidth: '55' },
              { type: 'campo', dataField: "descrizione", dataType: "", caption: "Comune", colWidth: '300' },
              { type: 'campo', dataField: "siglaProvincia", dataType: "string", caption: "PR.", colWidth: '40' },
              { type: 'campo', dataField: "cap", dataType: "string", caption: "CAP", colWidth: '70' },


            ]
          })


        }

      },

      {
        colVisible: false, orderGriglia: 8,
        type: 'campoSpecial',
        dataField: "stato",
        caption: "Stato",
        dataType: "",
        nCol: 4,
        validation: [{
          type: 'required', message: 'Stato obbligatorio'
        }],
        lista: {
          dataSource: 'statoEstero',
          valueExpr: 'iso',
          displayExpr: 'descrizione',
          static: false
        },
        editorType: 'dxSelectBox',

      },
      { type: 'empty',dataField: ""},

      {
        colVisible: false,
        orderGriglia: 6,
        type: 'campo',
        dataField: "cap",
        caption: "CAP",
        dataType: "",
        maxLength: "5",
        maxSize: 5,
        nCol: 4
      },
      {
        showInColumnChooser: true, allowHiding: false,
        orderGriglia: 7,
        type: 'campoSpecial',
        dataField: "provincia",
        caption: "Provincia",
        dataType: "",
        labelWidth:153,
        nCol: 6,
        validation: [{
          type: 'required', message: 'Provincia obbligatorio'
        }],
        lista: {
          dataSource: 'provincia',
          valueExpr: 'siglaProvincia',
          displayExpr: 'descrizione',
          static: false
        },
        editorType: 'dxSelectBox'

      },
      {
        type: 'empty',
        colSpan: '1',
        
        dataField: "", colVisible: false, dataType: "", hideOnEdit: false,
      },

      {
        showInColumnChooser: true, allowHiding: false,
        colVisible: true, orderGriglia: 9, type: 'campoSpecial', dataField: "idAttivitaFuoriUl", caption: "Attività", dataType: "", width: 46 * aspect,
        maxLength: "1",
        maxSize: 1,
        nCol: 10,
        colSpan: 3,

        validation: [{
          type: 'required', message: 'Attivita fuori obbligatorio'
        }],
        lista: {
          dataSource: 'attivitaFuoriUl',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false
        },
        editorType: 'dxSelectBox',

      },




      {
        colVisible: false,
        orderGriglia: 10,
        type: 'campoData',
        dataField: "dataInizio",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        nCol:4,
        caption: "Data Inizio",
        

      },
      {type: 'empty', dataField: "", nCol:2},
      {
        colVisible: false,
        orderGriglia: 11,
        type: 'campoData',
        dataField: "dataFine",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date", 
        caption: "Data Fine",
        nCol:4,
        labelWidth:88
      },
      
    
      
      {
        trueText: 'Si',
        falseText: 'No',
        colVisible: false,
        orderGriglia: 12,
        showEditorAlways: false,
        type: 'campo',
        dataType: "boolean",
        dataField: "isSospeso",
        editorType: "dxCheckBox",
        caption: "Sospeso",
        colSpan:3
      },

      {type: 'empty',dataField: "", dataType: ""},
      {type: 'empty',dataField: "", dataType: ""}


    ]
  },
]